import React, { useCallback, useMemo } from 'react';
import { DateRange } from 'react-date-range';
import PropTypes from 'prop-types';

export const DatePickerRange = ({
  startDateRange,
  setStartDateRange,
  disabledMaxDate,
  endDateRange,
  setEndDateRange,
  months,
  direction,
  rangeColors,
  className,
  shownDate,
}) => {
  const handleSelect = useCallback(({ selection: { startDate, endDate } }) => {
    setStartDateRange(startDate);
    setEndDateRange(endDate);
  });

  const ranges = useMemo(() => {
    return [
      {
        startDate: startDateRange,
        endDate: endDateRange,
        key: 'selection',
      },
    ];
  }, [startDateRange, endDateRange]);

  return (
    <div>
      <DateRange
        dateDisplayFormat="YYYY.MM.DD"
        fixedHeight
        ranges={ranges}
        onChange={handleSelect}
        showDateDisplay={false}
        months={months}
        rangeColors={rangeColors}
        direction={direction}
        className={className}
        weekdayDisplayFormat="EEEEE"
        monthDisplayFormat="MMMM yyyy"
        maxDate={disabledMaxDate}
        shownDate={shownDate}
      />
    </div>
  );
};

DatePickerRange.propTypes = {
  startDateRange: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setStartDateRange: PropTypes.func.isRequired,
  endDateRange: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setEndDateRange: PropTypes.func.isRequired,
  months: PropTypes.number,
  direction: PropTypes.string,
  rangeColors: PropTypes.array,
  className: PropTypes.string,
  disabledMaxDate: PropTypes.object,
  shownDate: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/common/DatePickerRange/index.jsx